import {
  Descriptions,
  Divider,
  Empty,
  notification,
  Skeleton,
  Tag,
} from "antd";
import Checkbox from "antd/lib/checkbox/Checkbox";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import Modal from "antd/lib/modal/Modal";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React, { createContext, useContext, useState } from "react";
import ReactQuill from "react-quill";
import renderHTML from "react-render-html";
import _ from "underscore";
import {
  getCurrentUser,
  reactQuiltoolbarOptions,
} from "../../../../Utility/modules/helpers";
import RequestStore from "../store/requeststore";
import EbendoDailyProductionStore from "../../store/ebendodailyproductionstore";
import TextArea from "antd/lib/input/TextArea";
import { toJS } from "mobx";
import MainStore from "../../../home/store/mainStore";

const EbendoStoreCtx = createContext(EbendoDailyProductionStore);
const requestStoreCtx = createContext(RequestStore);
const mainStorectx = createContext(MainStore);
export const EbendoApprovalDialog = observer(() => {
  const requestStore = useContext(requestStoreCtx);
  const ebendoDailyProductionStore = useContext(EbendoStoreCtx);
  const mainStore = useContext(mainStorectx);
  const [overrIdeRemark, setOverrIdeRemark] = useState(false);

  return (
    <Modal
      centered
      visible={requestStore.showEbendoApprovalDialog}
      title={"EBENDO Production Sign-off approval"}
      onCancel={() => {
        requestStore.showEbendoApprovalDialog = false;
        setOverrIdeRemark(false);
      }}
      width={"60%"}
      okText="Approve"
      okButtonProps={{ loading: requestStore.isSaving }}
      onOk={async () => {
        try {
          ebendoDailyProductionStore.initFormaData.approver =
            getCurrentUser()?.fullName;
          let { reqView } = await requestStore.saveApprovedProduction(
            [ebendoDailyProductionStore.initFormaData],
            _.map(requestStore.selAppItems, (x) => toJS(x)),
            requestStore.approverComment,
            getCurrentUser()?.fullName,
            mainStore.assetContextId
          );

          if (requestStore.selAppItems.length === 1) {
            requestStore.myApprovals.delete(reqView.requestApprovalId);
            requestStore.allApprovals.delete(reqView.requestApprovalId);
          } else {
            reqView.forEach((rv) => {
              requestStore.myApprovals.delete(rv.requestApprovalId);
              requestStore.allApprovals.delete(rv.requestApprovalId);
            });
          }

          requestStore.showEbendoApprovalDialog = false;
          requestStore.selAppItems = [];
          setOverrIdeRemark(false);
          notification.success({
            message: "SPARS Feedback",
            description: "request approved successfully",
          });
        } catch (error) {
          notification.error({
            message: "SPARS Feedback",
            description: error.response && error.response.text,
          });
        }
      }}
    >
      {ebendoDailyProductionStore.isLoadingDailyProd ? (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <Form layout="vertical">
          {requestStore.selAppItems.length > 1 && (
            <>
              <Divider>Approval for:</Divider>
              <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12">
                    <span style={{ color: "red", fontWeight: "bold" }}>
                      {requestStore.selAppItems.length}
                    </span>{" "}
                    Producing Day
                    {requestStore.selAppItems.length > 1 ? "s" : ""}
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12">
                    {requestStore.selAppItems.map((d) => (
                      <Tag key={d.productionDate}>
                        {moment(d.productionDate).format("dddd MMM Do YYYY")}
                      </Tag>
                    ))}
                  </div>
                </div>
              </div>
            </>
          )}
          {requestStore.selAppItems.length === 1 && (
            <Divider>
              {`EBENDO JV Production (Refer) Date: `}
              <span style={{ color: "#1890ff" }}>
                {moment(
                  ebendoDailyProductionStore.initFormaData.productionDate
                ).format("dddd, MMMM DD,YYYY")}
              </span>
            </Divider>
          )}
          {requestStore.selAppItems.length === 1 && (
            <div>
              {" "}
              {overrIdeRemark === true ? (
                <>
                  <Divider>FIELD ENGINEER REMARKS/NOTES</Divider>
                  <div className="ms-Grid" dir="ltr">
                    {" "}
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm12">
                        <FormItem
                          label="EBENDO DAILY  PRODUCTION REMARKS"
                          labelAlign="left"
                        >
                          <ReactQuill
                            modules={{ toolbar: reactQuiltoolbarOptions }}
                            onChange={(value) => {
                              ebendoDailyProductionStore.initFormaData.remarks =
                                value;
                            }}
                            value={
                              ebendoDailyProductionStore.initFormaData?.remarks
                            }
                            style={{ minHeight: "300px" }}
                            placeholder="Enter Remarks here"
                          />{" "}
                        </FormItem>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <Descriptions
                    title="PRODUCTION REMARKS"
                    size={"small"}
                    bordered
                  >
                    <Descriptions.Item label="EBENDO DAILY PRODUCTION REMARKS">
                      {_.isNull(
                        ebendoDailyProductionStore.initFormaData.remarks
                      ) ? (
                        <>
                          <Empty description="No Remarks" />
                        </>
                      ) : (
                        <>
                          {renderHTML(
                            ebendoDailyProductionStore.initFormaData.remarks
                          )}
                        </>
                      )}
                    </Descriptions.Item>
                  </Descriptions>
                </>
              )}
            </div>
          )}
          {requestStore.selAppItems.length === 1 && (
            <div className="ms-Grid" dir="ltr" style={{ paddingTop: "10px" }}>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm6">
                  <Checkbox
                    onChange={(e) => {
                      setOverrIdeRemark(e.target.checked);
                    }}
                  >
                    <span style={{ color: "red" }}>
                      Edit Field Engineer's Remarks
                    </span>
                  </Checkbox>
                </div>
              </div>
            </div>
          )}

          <FormItem label="Approver Remarks" labelAlign="top">
            <TextArea
              label=" "
              rows={5}
              name="description"
              onChange={({ target }) => {
                ebendoDailyProductionStore.initFormaData.approverComment =
                  target.value;
                requestStore.approverComment = target.value;
              }}
            />
          </FormItem>
        </Form>
      )}
    </Modal>
  );
});

